<template>
  <div>
    <van-dialog
      :value="isOpen"
      class="new-product-select-dialog"
      title="选择商品"
      show-cancel-button
      confirm-button-text="确定"
      cancel-button-text="取消"
      :lazy-render="true"
      @confirm="onConfirm"
      @cancel="onCancel"
    >
      <div class="new-product-select">
        <div class="filter-bar">
          <van-field
            v-if="type !== 'order'"
            v-model="keyword"
            label="外部编号/编号/名称"
            placeholder="请输入外部编号、编号或名称"
            clearable
            autocomplete="off"
            @keyup.enter.native="onSearch"
          />
          <!-- <van-field
            :value="categoryName"
            label="所属类目"
            placeholder="请选择类目"
            readonly
            is-link
            inputmode="none"
            @click="categoryVisible = true"
          /> -->
          <div class="filter-actions">
            <!-- <van-button size="small" 
              @click="onReset"
              :loading="loading"
              >重置</van-button> -->
            <van-button
              type="primary"
              size="small"
              :loading="loading"
              @click="onSearch"
            >
              查询
            </van-button>
          </div>
        </div>

        <div class="list-wrap">
          <div v-if="!list.length && !loading" class="empty-tip">暂无商品</div>
          <div
            v-for="row in list"
            :key="getRowKey(row)"
            class="product-row"
            @click="toggleRow(row)"
          >
            <div class="check-col">
              <span
                class="select-mark"
                :class="{ on: isChecked(row), round: !isMultiple }"
              />
            </div>
            <div class="info-col">
              <div class="product-name">{{ getRowName(row) }}</div>
              <div class="product-meta">
                <div class="meta-line">
                  <span>编号 {{ getRowCode(row) }}</span>
                  <span v-if="getRowExternalCode(row)">外部编号 {{ getRowExternalCode(row) }}</span>
                </div>
                <div
                  v-if="row.stockNum != null || row.retailPrice != null || row.taxPrice != null"
                  class="meta-line"
                >
                  <span v-if="row.stockNum != null">库存 {{ row.stockNum }}</span>
                  <span v-if="row.retailPrice != null || row.taxPrice != null">
                    ￥{{ row.retailPrice || row.taxPrice }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="pager">
          <span class="pager-total">共 {{ totalCount }} 条</span>
          <van-button
            size="mini"
            :disabled="pageIndex <= 1 || loading"
            @click="changePage(-1)"
          >
            上一页
          </van-button>
          <span class="pager-num">{{ pageIndex }}/{{ totalPage }}</span>
          <van-button
            size="mini"
            :disabled="pageIndex >= totalPage || loading"
            @click="changePage(1)"
          >
            下一页
          </van-button>
        </div>
      </div>
    </van-dialog>

    <CategorySelect
      :visible="categoryVisible"
      @confirm="onCategoryConfirm"
    />
  </div>
</template>

<script>
import { reqProduct } from "../service/api/product";
import { queryPurchaseProductList } from "../service/api/purchase/order";
import { queryRetailProductList } from "../service/api/retail/out";
import CategorySelect from "./categorySelect.vue";

export default {
  name: "newProductSelect",
  components: { CategorySelect },
  props: {
    type: { type: String, default: "default" },
    columnsType: { type: String, default: "radio" },
    scId: { type: String, default: "" },
    visible: { type: Boolean, default: false },
    requestParams: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      loading: false,
      keyword: "",
      categoryId: "",
      categoryName: "",
      categoryVisible: false,
      list: [],
      pageIndex: 1,
      pageSize: 20,
      totalCount: 0,
      selectedMap: {},
    };
  },
  computed: {
    isMultiple() {
      return this.columnsType === "checkbox";
    },
    isOpen() {
      return this.visible;
    },
    totalPage() {
      return Math.max(1, Math.ceil(this.totalCount / this.pageSize) || 1);
    },
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.clearSelection();
          this.pageIndex = 1;
          this.$nextTick(() => this.fetchList());
        }
      },
    },
  },
  methods: {
    getRowKey(row) {
      if (!row) return "";
      if (this.type === "retail" || this.type === "order") {
        return row.productId || row.id || "";
      }
      return row.id || row.productId || "";
    },
    getRowName(row) {
      return row.productName || row.name || "";
    },
    getRowCode(row) {
      return row.productCode || row.code || row.productId || "";
    },
    getRowExternalCode(row) {
      return (row && (row.externalCode || row.productExternalCode)) || "";
    },
    isChecked(row) {
      const key = this.getRowKey(row);
      return Boolean(key && this.selectedMap[key]);
    },
    clearSelection() {
      this.selectedMap = {};
    },
    toggleRow(row) {
      const key = this.getRowKey(row);
      if (!key) return;
      if (this.isMultiple) {
        if (this.selectedMap[key]) {
          this.$delete(this.selectedMap, key);
        } else {
          this.$set(this.selectedMap, key, row);
        }
        return;
      }
      this.selectedMap = { [key]: row };
    },
    onSearch() {
      this.pageIndex = 1;
      this.fetchList();
    },
    onReset() {
      this.keyword = "";
      this.categoryId = "";
      this.categoryName = "";
      this.pageIndex = 1;
      this.fetchList();
    },
    changePage(delta) {
      const next = this.pageIndex + delta;
      if (next < 1 || next > this.totalPage) return;
      this.pageIndex = next;
      this.fetchList();
    },
    onCategoryConfirm(row) {
      this.categoryVisible = false;
      if (!row || !Object.keys(row).length) return;
      this.categoryName = row.name || "";
      this.categoryId = row.id || "";
    },
    buildParams() {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        ...(this.requestParams || {}),
      };
      const keyword = (this.keyword || "").trim();
      if (keyword) {
        params.condition = keyword;
      }
      if (this.categoryId) {
        params.categoryId = this.categoryId;
      }
      if (this.scId) {
        params.scId = this.scId;
      }
      return params;
    },
    async fetchList() {
      if ((this.type === "retail" || this.type === "order") && !this.scId) {
        return;
      }
      this.loading = true;
      try {
        let res;
        if (this.type === "order") {
          res = await queryPurchaseProductList(this.buildParams());
        } else if (this.type === "retail") {
          res = await queryRetailProductList({
            isReturn: false,
            ...this.buildParams(),
          });
        } else {
          res = await reqProduct(this.buildParams());
        }
        const data = (res && res.data) || {};
        this.list = data.datas || [];
        this.totalCount = Number(data.totalCount || 0);
        if (data.pageIndex) {
          this.pageIndex = Number(data.pageIndex);
        }
        if (data.pageSize) {
          this.pageSize = Number(data.pageSize);
        }
      } catch (error) {
        if (error && (error.__CANCEL__ || error.isCanceled)) return;
        this.list = [];
        this.totalCount = 0;
      } finally {
        this.loading = false;
      }
    },
    getSelectedList() {
      return Object.keys(this.selectedMap).map((key) => this.selectedMap[key]);
    },
    onConfirm() {
      // 与旧组件一致：确定只把当前勾选的行回传给父页面
      this.$emit("confirm", this.getSelectedList());
    },
    onCancel() {
      this.$emit("confirm", []);
    },
  },
};
</script>

<style lang="less" scoped>
.new-product-select {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f7f8fa;
}
.filter-bar {
  flex-shrink: 0;
  background: #fff;
  border-bottom: 1px solid #ebedf0;
}
.filter-actions {
  display: flex;
  justify-content: flex-end;
  padding: 6px 16px 10px;
}
.filter-actions .van-button + .van-button {
  margin-left: 8px;
}
.list-wrap {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  background: #fff;
}
.empty-tip {
  padding: 40px 0;
  text-align: center;
  color: #c8c9cc;
  font-size: 13px;
}
.product-row {
  display: flex;
  align-items: flex-start;
  padding: 10px 12px;
  border-bottom: 1px solid #f2f3f5;
}
.check-col {
  flex: 0 0 28px;
  width: 28px;
  padding-top: 2px;
}
.select-mark {
  display: block;
  width: 16px;
  height: 16px;
  box-sizing: border-box;
  border: 1px solid #c8c9cc;
  border-radius: 2px;
  background: #fff;
}
.select-mark.round {
  border-radius: 50%;
}
.select-mark.on {
  border-color: #07c160;
  background: #07c160;
  box-shadow: inset 0 0 0 2px #fff;
}
.info-col {
  flex: 1;
  min-width: 0;
}
.product-name {
  font-size: 14px;
  color: #323233;
  line-height: 20px;
  word-break: break-all;
}
.product-meta {
  margin-top: 4px;
  font-size: 12px;
  color: #969799;
}
.meta-line {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 8px;
}
.meta-line + .meta-line {
  margin-top: 2px;
}
.meta-line span {
  min-width: 0;
  max-width: 100%;
  word-break: break-all;
}
.pager {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 8px 12px;
  background: #fff;
  border-top: 1px solid #ebedf0;
}
.pager .van-button {
  margin-left: 8px;
}
.pager-total,
.pager-num {
  font-size: 12px;
  color: #646566;
}
.pager-num {
  margin-left: 8px;
}
::v-deep .filter-bar .van-field {
  padding: 8px 16px;
}
::v-deep .filter-bar .van-field__label {
  width: 8.6em;
  font-size: 12px;
  color: #646566;
  white-space: nowrap;
}
</style>

<!-- 弹窗挂到 body 上，scoped 选不中，这里单独限制高度，避免整页被列表撑出屏幕 -->
<style lang="less">
.new-product-select-dialog {
  display: flex;
  flex-direction: column;
  top: 50%;
  width: 92% !important;
  max-width: 420px;
  height: 80vh;
  max-height: 80vh;
  overflow: hidden;
  border-radius: 12px;
}
.new-product-select-dialog .van-dialog__header {
  flex-shrink: 0;
  padding-top: 16px;
}
.new-product-select-dialog .van-dialog__content {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.new-product-select-dialog .new-product-select {
  flex: 1;
  min-height: 0;
  height: auto;
}
.new-product-select-dialog .filter-bar .van-field__label {
  width: 8.6em;
  font-size: 12px;
  white-space: nowrap;
}
</style>
